/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.17",
    versionName: "0.2.0-nightly.2026.1.17",
    versionChannel: "nightly",
    buildDate: "2026-01-17T00:09:10.531Z",
    commitHash: "253b64310f54017a5941f8ca750ac520e1da5552",
};
